module.exports = __webpack_public_path__ + "static/media/stop-5.77ff8484.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-5.svg
// module id = 1372
// module chunks = 0